
import { ApiGetHierarchicalMemberOrganizationDto } from "@/api/generated/Api";
import { defineComponent, ref } from "@vue/composition-api";
import { PropType } from "vue";

export default defineComponent({
  name: "TheMemberOrganizaionModalTreeHierarchy",
  emits: ["update"],
  props: {
    buttonLabel: {
      type: String,
      default: "Velg arrangør",
      required: false,
    },
    memberOrgHierarchi: {
      type: Array as PropType<ApiGetHierarchicalMemberOrganizationDto[]> as [],
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  setup(_, { emit }) {
    const menuOpen = ref(false);

    const update = (item: ApiGetHierarchicalMemberOrganizationDto) => {
      emit("update", item);
      menuOpen.value = false;
    };

    return {
      update,
      menuOpen,
    };
  },
});
